import { TopBarProps } from './Types'
import Styles from './MobileTopBarContainer.module.scss'
import cx from 'classnames'

export const MobileTopBarContainer = ({ children, className, ...props }: TopBarProps) => {
  return (
    <div className={cx(Styles.wrapper, className)} data-theme={props['data-theme']} data-testid={props['data-testid']}>
      {children}
    </div>
  )
}
